import { FC, SVGProps } from 'react';

import { Icon as IconType } from 'src/types/components';

import CalendarIcon from 'assets/icons/banner/calendar.svg';
import EmergencyIcon from 'assets/icons/banner/emergency.svg';
import SuccessIcon from 'assets/icons/banner/success.svg';
import WarningIcon from 'assets/icons/banner/warning.svg';
import GradCapIcon from 'assets/icons/school.svg';

// to add an icon:
// add icon name as a select option for the Icon field (eg. in the `CoreAlertBanner` ACF definition in WordPress)
// add that name to the "Icon" type in 'src/types/components'
// add the corresponding icon svg to project, and map it to that name here
const IconMap: Record<IconType, FC<SVGProps<SVGSVGElement>>> = {
  emergency: EmergencyIcon,
  success: SuccessIcon,
  warning: WarningIcon,
  calendar: CalendarIcon,
  grad_cap: GradCapIcon,
};

type IconProps = {
  type: IconType;
};

const getIcon = ({ type }: IconProps): FC<SVGProps<SVGSVGElement>> | null => {
  const Icon = IconMap[type];
  if (!Icon) {
    return null;
  }
  return Icon;
};

export default getIcon;
